module.exports = __webpack_public_path__ + "static/media/home.be770e0a.svg";